import { HttpService } from '@/infra/http'

export type TLeadRepresadoDetalhes = {
  id: string
  nome: string
  cpf?: string | null
  quantidadeDocumentosEnviados: number
  telefone?: string | null
  empreendimentos: string[]
}

export class GetLeadRepresadoPorIdService extends HttpService {
  async execute({ id }: { id: string }) {
    return this.http.get<TLeadRepresadoDetalhes>(`api/v2/Cliente/leadRepresado/${id}`)
  }
}
